module.exports = __webpack_public_path__ + "static/media/ic_lock_hover.5a8c5ea1.svg";